import React from 'react'
import PropTypes from 'prop-types'

import { Flex } from '@chatterbug/aaron'

const Filler = ({ completeFraction, barColor }) => {
  return (
    <Flex
      alignSelf="flex-end"
      borderRadius="1x"
      bg={barColor}
      width="5px"
      height={completeFraction ? `${completeFraction}%` : 0}
    />
  )
}

Filler.propTypes = {
  completeFraction: PropTypes.number,
  barColor: PropTypes.string.isRequired,
}

export default Filler
